/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading[_ngcontent-%COMP%]{position:fixed;width:100%;z-index:10000}.slider[_ngcontent-%COMP%]{position:absolute;height:8px;width:100%;overflow-x:hidden}.line[_ngcontent-%COMP%]{position:absolute;background:#46a5f8;width:150%;height:5px}.subline[_ngcontent-%COMP%]{position:absolute;background:#06589f;height:5px}.inc[_ngcontent-%COMP%]{-webkit-animation:2s infinite increase;animation:2s infinite increase}@-webkit-keyframes increase{from{left:0;width:5%}to{left:100%;width:100%}}@keyframes increase{from{left:0;width:5%}to{left:100%;width:100%}}"];
export { styles as styles };
